import { createAction, props } from '@ngrx/store';

export const resetSession = createAction('[GAINSIGHT] Reset/Logout Session ');

export const pushUsersActiveEntitlements = createAction(
  '[USERS_ENTITLEMENTS] Get Users Active Unallocated Entitlements',
  props<{ value: number }>(),
);
